<template>
    <div class="search-panel__sorting" ref="root">
        <strong>Sorteren:</strong>
        <select name="select" v-model="activeValue" @change="addSorting"  class="basic-select" ref="select">
<!--            <option value="">Sorteer op </option>-->
            <option v-for="item in options" :value="item.slug" >{{ item.title}}</option>
        </select>
    </div>
</template>
<script>
import {useStore} from 'vuex'
import {computed, ref, watchEffect} from 'vue'
import Choices from '../../../../../assets/vendor/choices.js';

export default {
    name: "Sorting",
    setup() {
        const store = useStore()
        const root = ref(null)
        const select = ref(null)
        const activeValue = ref(null)
        const active = computed(() => sorting.value?.find(sort => sort.active) ??[])
        const dropdownActive = ref(false)
        const sorting = computed(() => store.getters.data?.sorting ?? [])
        const options = computed(() => sorting.value ?? [])

        const toggleDropdown = () => dropdownActive.value = !dropdownActive.value
        const addSorting = (slug) => {
            store.dispatch('setSorting', activeValue.value);
        }

        watchEffect( () => {
           activeValue.value = active.value.slug;
        });

        return {
            sorting,
            root,
            select,
            options,
            activeValue,
            dropdownActive,
            addSorting,
            toggleDropdown
        }
    }
}
</script>